import { AttendingEventsState } from "./attendingEvents.types";

export const initialState: AttendingEventsState = {
  data: [],
  firstPage: [],
  currentPage: {
    data: [],
    pagination: {
      current_page: 0,
      limit: 0,
      total_items: 0,
      total_pages: 0,
    },
  },
  loading: false,
  error: null,
};